import React from 'react';

import styles from './styles.module.scss';

const Loader = () => {
  return (
    <div className={styles.loaderContainer}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 26"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6508 0H20.6158L16.6098 9.92527L16.7701 9.5282L24 26H20.1923L18.8044 22.5541H11.5223L10.1344 26H6.41682L6.66917 25.4135L10.567 16.4001C9.26797 17.0539 7.82934 17.3689 6.38077 17.3165C3.91138 17.3257 1.38791 16.5696 0 15.4653L1.23019 12.6655C2.74904 13.7417 4.55216 14.3263 6.4033 14.3426C8.55276 14.3426 9.42696 13.6049 9.42696 12.6197C9.42696 11.3733 7.85881 10.9975 6.02028 10.5576C3.42922 9.9436 0.306421 9.20127 0.306421 5.70955C0.306421 2.9785 2.46038 0.705675 6.92152 0.705675C8.82795 0.666143 10.7087 1.15735 12.3605 2.12619L11.243 4.95347C9.92839 4.15346 8.43073 3.71743 6.89899 3.68876C4.74502 3.68876 3.91588 4.51357 3.91588 5.52168C3.91588 6.74974 5.48404 7.11632 7.32257 7.54706C9.57567 8.06944 12.1893 8.68805 12.8697 11.0663L17.6508 0ZM12.694 19.7314L15.1769 13.5774L17.6643 19.7314H12.694Z"
          fill="#000"
        />
      </svg>
    </div>
  );
};

export default Loader;
